<div class="jeopardy-multiplayer-grid"> 
    <div></div>
    <div>
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
    <div></div>
</div>
